import Hero from "blocks/hero/hero.component";
import TextBlock from "blocks/textBlock/textBlock.block";
import VideoBlock from "blocks/videoBlock/videoBlock.block";
import Accordion from "blocks/accordion/accordion.component";
import Gallery from "blocks/gallery/gallery.component";
// import Poster from "blocks/poster/poster.component";
import React, { useContext } from "react";
import ShellContext from "shell/shell.context";
import { PHASES } from "const/phases.const";
import Poster from "blocks/poster/poster.component";
import Counter from "blocks/counter/counter.block";

const Blocks: any = {
  hero: Hero,
  textBlock: TextBlock,
  videoBlock: VideoBlock,
  accordion: Accordion,
  gallery: Gallery,
  poster: Poster, 
  counter: Counter
};

interface Props {
  data: {
    type: string;
    phase?: PHASES[];
    data: any;
  }[];
}

const BlockLoop: React.FC<Props> = (props) => {
  const context = useContext(ShellContext);
  return (
    <>
      {props.data.map((item, key) => {
        const blockName: string = item.type;

        // check phase
        if (!!item.phase && !item.phase.includes(context.phase) && context.phaseOn) {
          return false;
        }

        if (!Blocks[blockName]) {
          return null;
        }
        //
        const block: React.FC<any> = Blocks[blockName];
        //
        const data: any = item.data;
        //
        return React.createElement(block, {
          ...data,
          key: key,
        });
      })}
    </>
  );
};

export default BlockLoop;
